module.exports = __webpack_public_path__ + "static/media/Default-profil.6276f9ba.jpg";